import { Button, Input, TextField } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import {
	BOX_SHADOWS,
	DATA_CLEAN_FILTERS_CAT,
	DATA_CLEAN_FILTERS_NUM,
	DATA_TYPES,
	EXTRA_HEADERS,
	FONTS,
	PRIMARY_COLOR,
	SECONDARY_COLOR,
} from "../../constants";
import { cleanDataFilterType, stateType, stateTypeF } from "../../state";

import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { KeyboardArrowDown } from "@material-ui/icons";
import React from "react";
import add_filter from "../../media/filter-4.svg";
import { trimString } from "../Common/helpers";

import { addAlpha } from "../../helpers/DataHelpers";
import Dataset from "../../MachineLearning/Dataset";
import { makeHistData } from "../Common/makeHistData";
import { isNumber } from "./FilterButton";
import {
	applyFiltersToData,
	checkIfDuplicate,
	makeCleanDataFilter,
} from "./filters";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		listRoot: {
			width: "100%",
			backgroundColor: theme.palette.background.paper,
			position: "relative",
			height: "100%",
			overflow: "auto",
			fontFamily: FONTS,
		},
		container: {
			boxShadow: BOX_SHADOWS,
			backgroundColor: "white",
			width: "70%",
			display: "flex",
			flexDirection: "column",
			fontFamily: FONTS,
			borderRadius: "10px",
			overflow: "hidden",
		},
		listContainer: {
			marginTop: "5px",
			display: "flex",
			flexDirection: "row",
			height: "90%",
			fontFamily: FONTS,
			width: "100%",
		},
		catIcons: {
			width: "30px",
			height: "30px",
			backgroundColor: PRIMARY_COLOR,
			borderRadius: "5px",
			textAlign: "center",
			fontWeight: "bold",
			lineHeight: "30px",
			marginRight: "5px",
			color: "white",
			marginLeft: "20px",
		},
		colTitle: { width: "100%", textAlign: "center" },
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120,
		},
		selectEmpty: {
			marginTop: theme.spacing(2),
		},
		dropDownText: {},
		dropDown: {
			width: "180px",
			height: "30px",
			border: "solid",
			marginLeft: "0px",
			borderRadius: "5px",
			borderColor: "rgba(0,0,0,0.2)",
			borderWidth: "2px",
			marginBottom: "20px",
			display: "flex",
			flexDirection: "row",
			transition: "0.3s",
			cursor: "pointer",
			backgroundColor: "white",
			"&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
		},
		root: {
			width: 300,
		},
		filterRow: { display: "flex", flexDirection: "row" },
		closeButton: {
			marginTop: "34px",
			marginLeft: "15px",
			marginRight: "5px",
			height: "17px",
			width: "17px",
			cursor: "pointer",
			"&:hover": { transform: "scale(1.1)" },
		},
		inputLabel: {
			color: PRIMARY_COLOR,
			fontFamily: FONTS,
			"&.Mui-focused": { color: PRIMARY_COLOR },
		},
		selectUnderline: {
			"&:before": {
				borderBottom: `1px solid ${SECONDARY_COLOR}`,
			},
			"&:after": {
				borderBottom: `2px solid ${SECONDARY_COLOR}`,
			},
			"&:hover:before": {
				borderBottom: `1px solid ${SECONDARY_COLOR}`,
			},
		},
		floatingLabelFocusStyle: {
			"&.Mui-focused": {
				color: PRIMARY_COLOR,
			},
			color: PRIMARY_COLOR,
			fontFamily: FONTS,
		},
		textField: {
			"& .MuiInputBase-input": {
				color: PRIMARY_COLOR, // Text color
			},
			"& .MuiInput-underline:before": {
				borderBottomColor: SECONDARY_COLOR, // Semi-transparent underline
			},
			"& .MuiInput-underline:hover:before": {
				borderBottomColor: SECONDARY_COLOR, // Solid underline on hover
			},
			"& .MuiInput-underline:after": {
				borderBottomColor: SECONDARY_COLOR, // Solid underline on focus
			},
		},
	})
);

type filterInputType = { state: stateTypeF; title: string };
function OperationDropDown({ state }: stateType) {
	const classes = useStyles();
	let col = state.saveState.dataset.getColumn(
		state.saveState.cleanData.cleanHistSelected
	);
	if (col === undefined) {
		return <div></div>;
	}

	let values = col.availableColumnTypes.includes(DATA_TYPES.number)
		? Object.values(DATA_CLEAN_FILTERS_NUM)
		: Object.values(DATA_CLEAN_FILTERS_CAT);

	function handleChange(e) {
		const colValue = String(e.target.value);
		let filter = state.currentDataFilter;
		filter.operation = colValue;
		state.setCurrentDataFilter(filter);
	}

	return (
		<FormControl
			className={classes.formControl}
			style={{ fontFamily: FONTS }}
		>
			<InputLabel
				id="demo-customized-select-label"
				className={classes.inputLabel}
				shrink={true}
			>
				{"Operation"}
			</InputLabel>
			<Select
				labelId="demo-customized-select-label"
				id="demo-customized-select"
				value={state.currentDataFilter.operation}
				onChange={handleChange}
				style={{ width: "150px", fontFamily: FONTS }}
				input={
					<Input
						classes={{
							underline: classes.selectUnderline,
						}}
					/>
				}
			>
				{values.map((val2) => (
					<MenuItem value={val2}>{val2}</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}

function validateFilters(filters: cleanDataFilterType[], dataset: Dataset) {
	let allValid = true;
	for (let filter of filters) {
		let col = dataset.getColumn(filter.column);
		let validate = false;
		if (col === undefined) {
			if (filter.column === EXTRA_HEADERS.row_number) {
				validate = true;
			} else {
				validate = false;
			}
		} else if (col.columnType === DATA_TYPES.number) {
			validate = true;
		}
		if (validate) {
			if (!isNumber(filter.value)) {
				allValid = false;
			}
			if (!filter.drop_row && !isNumber(filter.replace_with)) {
				allValid = false;
			}
		}
	}
	return allValid;
}

function ValuesInput({ state, title }: filterInputType) {
	const classes = useStyles();

	function handleChage(e) {
		const colValue = String(e.target.value);
		let filter = state.currentDataFilter;
		if (title === "Replace With") {
			filter.replace_with = colValue;
		} else {
			filter.value = colValue;
		}

		state.setCurrentDataFilter(filter);
	}

	let value = state.currentDataFilter.value;
	if (title === "Replace With") {
		value = state.currentDataFilter.replace_with;
	}

	let toDisable = title === "Replace With" && state.dropRowsFilterSelected;

	return (
		<TextField
			id="standard-basic"
			label={title}
			variant="standard"
			style={{
				width: "150px",
				marginTop: "8px",
				marginRight: "20px",
				fontFamily: FONTS,
				marginLeft: "8px",
			}}
			disabled={toDisable}
			value={value}
			onChange={handleChage}
			inputProps={{
				maxLength: 25,
			}}
			className={classes.textField}
			InputLabelProps={{
				className: classes.floatingLabelFocusStyle,
				shrink: true,
			}}
		/>
	);
}

function ValueDropDown({ state, title }: filterInputType) {
	const classes = useStyles();
	let col = state.saveState.dataset.getColumn(
		state.saveState.cleanData.cleanHistSelected
	);
	if (col === undefined) {
		return <div></div>;
	}
	let values = col.allClasses;

	function handleChange(e) {
		const colValue = String(e.target.value);
		let filter = state.currentDataFilter;
		if (title === "Replace With") {
			filter.replace_with = colValue;
		} else {
			filter.value = colValue;
		}
		state.setCurrentDataFilter(filter);
	}

	let value = state.currentDataFilter.value;
	if (title === "Replace With") {
		value = state.currentDataFilter.replace_with;
	}

	let toDisable = title === "Replace With" && state.dropRowsFilterSelected;

	return (
		<FormControl
			className={classes.formControl}
			style={{ fontFamily: FONTS, marginLeft: "30px" }}
			disabled={toDisable}
		>
			<InputLabel
				id="demo-customized-select-label"
				className={classes.inputLabel}
				shrink={true}
			>
				{title}
			</InputLabel>
			<Select
				labelId="demo-customized-select-label"
				id="demo-customized-select"
				value={value}
				onChange={handleChange}
				style={{ width: "150px", fontFamily: FONTS }}
				input={
					<Input
						classes={{
							underline: classes.selectUnderline,
						}}
					/>
				}
			>
				{values.map((val2) => (
					<MenuItem value={val2}>{val2}</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}

type filterMenuType = { state: stateTypeF; anchorEl; setAnchorEl };
function FilterMenu({ state, anchorEl, setAnchorEl }: filterMenuType) {
	const classes = useStyles();

	let col = state.saveState.dataset.getColumn(
		state.saveState.cleanData.cleanHistSelected
	);
	if (col === undefined) {
		return <div></div>;
	}
	const handleClose = () => {
		setAnchorEl(null);
	};
	function handleApply(e) {
		let filters = [...state.saveState.cleanData.cleanDataFilters];
		let currentFilter = { ...state.currentDataFilter };
		if (checkIfDuplicate(filters, currentFilter)) {
			setAnchorEl(null);
			return;
		}
		currentFilter.column = state.saveState.cleanData.cleanHistSelected;
		currentFilter.drop_row = [...[state.dropRowsFilterSelected]][0];
		currentFilter.index = filters.length;
		filters.push(currentFilter);
		let currentDataFilter = makeCleanDataFilter({
			operation: undefined,
			value: "",
			replace_with: "",
			column: undefined,
			drop_row: false,
			index: undefined,
		});

		// Get filtered data
		let { data } = applyFiltersToData(
			state.saveState.dataset.data,
			state.saveState.cleanData.cleanHistSelected,
			filters,
			state.saveState.cleanData.cleanRowsSelected,
			new Set()
		);

		let histData = makeHistData(
			data,
			col.columnType,
			state.saveState.cleanData.cleanRowsSelected,
			col.colStats.median
		);

		state.saveState.cleanData.cleanHistData = histData;
		state.setSaveState(state.saveState);
		for (let i = 0; i < filters.length; i++) {
			filters[i].index = i;
		}

		state.saveState.cleanData.cleanDataFilters = filters;
		state.setSaveState(state.saveState);
		setAnchorEl(null);
		state.setCurrentDataFilter(currentDataFilter);
	}

	function handleCheckClick() {
		let filter = state.currentDataFilter;
		filter.replace_with = "";
		filter.drop_row = !state.dropRowsFilterSelected;
		state.setCurrentDataFilter(filter);
		state.setDropRowsFilterSelected(!state.dropRowsFilterSelected);
	}

	function checkEnabled() {
		let dataFilter = state.currentDataFilter;
		let is_enabled = false;
		let allValid = validateFilters(
			[state.currentDataFilter],
			state.saveState.dataset
		);
		if (dataFilter.drop_row) {
			is_enabled =
				dataFilter.column !== "" &&
				dataFilter.operation !== "" &&
				dataFilter.value !== "";
		} else {
			is_enabled =
				dataFilter.column !== "" &&
				dataFilter.operation !== "" &&
				dataFilter.value !== "" &&
				dataFilter.replace_with !== "";
		}
		return is_enabled && allValid;
	}
	return (
		<Menu
			id="simple-menu"
			anchorEl={anchorEl}
			open={Boolean(anchorEl)}
			onClose={handleClose}
			style={{
				marginTop: "55px",
				marginLeft: "-32px",
				width: "800px",
			}}
		>
			<div
				style={{
					fontFamily: FONTS,
					margin: "20px",
					marginTop: "10px",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div style={{ fontWeight: "bold", marginLeft: "7px" }}>
					{state.saveState.cleanData.cleanHistSelected}
				</div>
				<div
					style={{
						fontSize: "14px",
						marginLeft: "7px",
						marginTop: "3px",
						color: "rgba(0,0,0,0.5)",
					}}
				>
					Select the values to filter out.
				</div>
			</div>
			<div style={{ display: "flex", flexDirection: "column" }}>
				<div
					className={classes.filterRow}
					style={{ marginLeft: "20px", marginTop: "-10px" }}
				>
					<OperationDropDown state={state}></OperationDropDown>
					{col.columnType === DATA_TYPES.number ? (
						<ValuesInput
							state={state}
							title={"Value"}
						></ValuesInput>
					) : (
						<ValueDropDown
							state={state}
							title={"Value"}
						></ValueDropDown>
					)}
					{col.columnType === DATA_TYPES.number ? (
						<ValuesInput
							state={state}
							title={"Replace With"}
						></ValuesInput>
					) : (
						<ValueDropDown
							state={state}
							title={"Replace With"}
						></ValueDropDown>
					)}
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						marginTop: "20px",
					}}
				>
					<Button
						onClick={handleApply}
						// variant={"outlined"}
						variant="contained"
						color="primary"
						disabled={!checkEnabled()}
						style={{
							fontFamily: FONTS,
							fontWeight: "bold",
							marginLeft: "25px",
							fontSize: "13px",
							marginRight: "20px",
							marginBottom: "20px",
							backgroundColor: SECONDARY_COLOR,

							color: !checkEnabled()
								? "rgba(255,255,255,0.6)"
								: "white",
							height: "35px",
							width: "130px",
						}}
					>
						Apply Filter
					</Button>
					<div
						style={{
							fontFamily: FONTS,
							fontSize: "14px",
							display: "flex",
							flexDirection: "row",
							cursor: "pointer",
						}}
						onClick={handleCheckClick}
					>
						<Checkbox
							checked={state.dropRowsFilterSelected}
							style={{
								width: "20px",
								height: "20px",
								marginLeft: "8px",
								color: addAlpha(PRIMARY_COLOR, 0.7),
							}}
							name="gilad"
						/>
						<div style={{ marginTop: "9px" }}>Drop Entire Rows</div>
					</div>
				</div>
			</div>
		</Menu>
	);
}

export function AddFilterDropDown({ state }: stateType) {
	const classes = useStyles();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		let filter = state.currentDataFilter;
		filter.value = "";
		filter.operation = "";
		filter.replace_with = "";
		filter.column = state.saveState.cleanData.cleanHistSelected;
		state.setCurrentDataFilter(filter);
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuSelect = (value) => {
		setAnchorEl(null);
	};

	let colNames: string[] = [];

	for (let col of state.saveState.dataset.columns) {
		if (col.columnType !== DATA_TYPES.unusable) {
			colNames.push(col.columnName);
		}
	}
	colNames = colNames.sort((a, b) =>
		a.toLowerCase() < b.toLowerCase() ? -1 : 1
	);

	return (
		<div>
			<div
				onClick={(event: any) => handleClick(event)}
				className={classes.dropDown}
				style={{ width: "140px" }}
			>
				<img
					style={{
						width: "17px",
						marginLeft: "5px",
						color: "white",
						marginTop: "0px",
						marginBottom: "0px",
					}}
					src={add_filter}
				></img>
				<div
					style={{
						width: "100%",
						height: "100%",
						textAlign: "left",
						lineHeight: "30px",
						marginLeft: "10px",
						fontFamily: FONTS,
					}}
				>
					Add Filter
				</div>
				<KeyboardArrowDown
					style={{
						marginTop: "4px",
						width: "22px",
						height: "22px",
						left: "-4px",
					}}
				></KeyboardArrowDown>
			</div>
			<FilterMenu
				state={state}
				anchorEl={anchorEl}
				setAnchorEl={setAnchorEl}
			></FilterMenu>
		</div>
	);
}

export function SelectColDropDown({ state }: stateType) {
	const classes = useStyles();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuSelect = (value) => {
		state.saveState.cleanData.cleanHistSelected = value;
		state.setSaveState(state.saveState);
		let filter = state.currentDataFilter;
		filter.column = value;
		state.setCurrentDataFilter(filter);

		let col = state.saveState.dataset.getColumn(value);

		// Get filtered data
		let { data } = applyFiltersToData(
			state.saveState.dataset.data,
			value,
			state.saveState.cleanData.cleanDataFilters,
			state.saveState.cleanData.cleanRowsSelected,
			new Set()
		);

		let histData = makeHistData(
			data,
			col.columnType,
			state.saveState.cleanData.cleanRowsSelected,
			col.colStats.median
		);

		state.saveState.cleanData.cleanHistData = histData;
		state.setSaveState(state.saveState);
		state.saveState.cleanData.cleanHistSelected = value;
		state.setSaveState(state.saveState);
		setAnchorEl(null);
	};

	let colNames: string[] = [];

	for (let col of state.saveState.dataset.columns) {
		if (col.columnType !== DATA_TYPES.unusable) {
			colNames.push(col.columnName);
		}
	}
	colNames = colNames.sort((a, b) =>
		a.toLowerCase() < b.toLowerCase() ? -1 : 1
	);

	return (
		<div>
			<div
				onClick={(event: any) => handleClick(event)}
				className={classes.dropDown}
			>
				<div
					style={{
						width: "100%",
						height: "100%",
						textAlign: "left",
						lineHeight: "30px",
						marginLeft: "10px",
						fontFamily: FONTS,
					}}
				>
					{trimString(
						state.saveState.cleanData.cleanHistSelected,
						15
					)}
				</div>
				<KeyboardArrowDown
					style={{
						marginTop: "4px",
						width: "22px",
						height: "22px",
						left: "-4px",
					}}
				></KeyboardArrowDown>
			</div>

			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				style={{
					marginTop: "43px",
					marginLeft: "-90px",
					maxWidth: "400px",
				}}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
			>
				{colNames.map((colName) => (
					<MenuItem
						style={{ width: "190px" }}
						onClick={() => handleMenuSelect(colName)}
						id={trimString(colName, 11)}
						value={colName}
					>
						{colName}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
}
